var _rect, _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHearfromouradvisers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 1.75,
    width: 73.5,
    height: 53.0213,
    rx: 8.25,
    stroke: "white",
    strokeWidth: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.331 27.2093C52.0963 27.7013 52.0963 28.82 51.331 29.3121L32.8463 41.197C32.0144 41.7319 30.9202 41.1346 30.9202 40.1456L30.9202 16.3757C30.9202 15.3868 32.0144 14.7895 32.8463 15.3243L51.331 27.2093Z",
    stroke: "white",
    strokeWidth: 3.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5005,
    cy: 68,
    r: 6.25,
    stroke: "white",
    strokeWidth: 3.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5853 69.7394C73.5518 69.7394 74.3353 68.9559 74.3353 67.9894C74.3353 67.0229 73.5518 66.2394 72.5853 66.2394V69.7394ZM61.1172 69.7394H72.5853V66.2394H61.1172V69.7394Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50003 66.2499C4.53353 66.2502 3.75024 67.0339 3.75049 68.0004C3.75074 68.9669 4.53445 69.7502 5.50095 69.7499L5.50003 66.2499ZM46.3721 66.2393L5.50003 66.2499L5.50095 69.7499L46.373 69.7393L46.3721 66.2393Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearfromouradvisers);
export default __webpack_public_path__ + "static/media/hear from our advisers.b25e5efae8840baedce522f46a3c2192.svg";
export { ForwardRef as ReactComponent };